import _       from 'underscore';
import { gql } from 'apollo-boost';

export const fragments = {}

export const queries = {
	
	EMPTY_QUERY: gql`
		query NoOpQuery{
			generalStore @client {
				nothing
			}
		}`,
	
	GET_STORE: ( items = {} ) => {
		
		let storeItems = _.extend( {}, {
			user:         'guid, welcomMssg',
			ui:           'guid',
			generalStore: `nothing`
		}, items );
		
		return gql`
			query GetUserStore{
				user @client {
					${ storeItems.user }
				}
				ui @client{
					${ storeItems.ui }
				}
				generalStore @client{
					${ storeItems.generalStore }
				}
			}`;
	}
	
}

export const mutations = {
	
	EMPTY_MUTATION: gql`
		mutation NoOpMutation{
			noop @client
		}`,
	
	UPDATE_USER_STORE: gql`
		mutation UpdateUserStore{
			updateStore(
				queriedItems:   $queriedItems,
				updateFunction: $updateFunction
			) @client
		}`
}

export const StoreQueries = {
	fragments,
	queries,
	mutations,
}
